var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm5 10.714h-5c-.429 0-.714-.285-.714-.714V3.571c0-.428.285-.714.714-.714s.714.286.714.714v5.715H15c.429 0 .714.285.714.714s-.285.714-.714.714z",
    fill: "#27282E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDBDNC41IDAgMCA0LjUgMCAxMEMwIDE1LjUgNC41IDIwIDEwIDIwQzE1LjUgMjAgMjAgMTUuNSAyMCAxMEMyMCA0LjUgMTUuNSAwIDEwIDBaTTE1IDEwLjcxNDNIMTBDOS41NzE0MyAxMC43MTQzIDkuMjg1NzEgMTAuNDI4NiA5LjI4NTcxIDEwVjMuNTcxNDNDOS4yODU3MSAzLjE0Mjg2IDkuNTcxNDMgMi44NTcxNCAxMCAyLjg1NzE0QzEwLjQyODYgMi44NTcxNCAxMC43MTQzIDMuMTQyODYgMTAuNzE0MyAzLjU3MTQzVjkuMjg1NzFIMTVDMTUuNDI4NiA5LjI4NTcxIDE1LjcxNDMgOS41NzE0MyAxNS43MTQzIDEwQzE1LjcxNDMgMTAuNDI4NiAxNS40Mjg2IDEwLjcxNDMgMTUgMTAuNzE0M1oiIGZpbGw9IiMyNzI4MkUiLz4KPC9zdmc+Cg==";
export { SvgTime as ReactComponent };